<template>
  <div>
    <v-dialog v-model="dialog" width="600px">
      <v-card>
        <v-card-title>
          {{ $t("lang.admin.purchase_order.add_box") }}
        </v-card-title>
        <v-card-text>
          <div v-if="errors.length">
            <b>{{ $t("lang.admin.purchase_order.error_list_title") }}</b>
            <div class="alert alert-danger" role="alert">
              <ul style="list-style-type: circle; margin: 10px">
                <li v-for="(error, index) in errors" :key="index">
                  {{ error }}
                </li>
              </ul>
            </div>
          </div>
        </v-card-text>
        <v-card-text>
          <form>
            <div class="form-row d-flex align-items-end">
              <div class="col-md-6">
                <v-text-field
                  :label="$t('lang.admin.purchase_order.add_box')"
                  outlined
                  v-model="box_id"
                ></v-text-field>
              </div>
              <div class="col-md-6"></div>
            </div>
            <div
              class="form-row"
              v-for="(item, index) in contentParams"
              :key="index"
            >
              <div class="select-box col-md-4" :disabled="gtins.length < 1">
                <v-combobox
                  :items="gtins"
                  :item-text="`gtin`"
                  :item-value="`gtin`"
                  v-model="item.gtin"
                  hide-details
                  :hide-no-data="!searchGtinInput"
                  :label="$t('lang.admin.purchase_order.gtin')"
                  outlined
                  :menu-props="{
                    closeOnClick: true,
                    closeOnContentClick: true,
                  }"
                  @update:search-input="getGtins"
                  :search-input.sync="searchGtinInput[index]"
                >
                  <template v-slot:no-data>
                    <v-list-item
                      @click="openAddGtinDialog"
                      v-if="searchGtinInput[index]"
                    >
                      <span class="subheading">Create &nbsp;</span>
                      <v-chip label small>
                        {{ searchGtinInput[index] }}
                      </v-chip>
                    </v-list-item>
                  </template></v-combobox
                >
              </div>
              <div class="select-box col-md-4 px-12">
                <v-text-field
                  :label="$t('lang.admin.purchase_order.qty')"
                  outlined
                  hide-details
                  v-model="item.quantity"
                ></v-text-field>
              </div>
              <div
                class="select-box col-md-1"
                v-if="index === contentParams.length - 1"
              >
                <v-icon x-large class="mt-2" @click="addNewContentRow"
                  >mdi-plus-circle-outline</v-icon
                >
              </div>
              <div class="select-box col-md-1" v-if="contentParams.length > 1">
                <v-icon x-large class="mt-2" @click="removeRow(index)"
                  >mdi-minus-circle-outline</v-icon
                >
              </div>
            </div>
            <div class="form-row">
              <v-progress-linear
                indeterminate
                color="primary"
                v-if="loading"
              ></v-progress-linear>
              <div class="mb-0 col-md-12">
                <v-btn text rounded type="reset" @click="close">
                  {{ $t("lang.admin.purchase_order.btn_cancel") }}
                </v-btn>
                <bx-btn class="mx-2" color="primary" @click="handleAddBox">
                  {{ $t("lang.admin.purchase_order.add_box") }}
                </bx-btn>
              </div>
            </div>
          </form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <AddGTINDialog ref="addGtinDialogRef" @close="dialog = true" />
  </div>
</template>

<script>
import AddGTINDialog from "./AddGTINDialog.vue";
export default {
  props: ["reception_id"],
  components: {
    AddGTINDialog,
  },
  data() {
    return {
      dialog: false,
      box_id: null,
      contentParams: [{ quantity: null, gtin: null }],
      gtins: [],
      loadingGtin: false,
      searchGtinInput: [],
      loading: false,
      orderCode: null,
      box: null,
      errors: [],
    };
  },
  methods: {
    open(orderCode) {
      this.orderCode = orderCode;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    async getGtins(value) {
    if (value && value.length >= 10) {
        this.loadingGtin = true;
        this.gtins = await this.$api.location.salesGtins({
          gtin__contains: value,
        });
        this.loadingGtin = false;
      }
    },
    removeRow(index) {
      this.contentParams.splice(index, 1);
    },
    openAddGtinDialog() {
      this.dialog = false;
      setTimeout(() => {
        this.$refs.addGtinDialogRef.open();
        this.searchGtinInput = [];
      }, 0);
    },
    async handleAddBox() {
      this.errors = [];
      if (this.contentParams.length > 0) {
        try {
          this.loading = true;
          this.box = await this.$api.reception_boxes.createBox({
            codebar: this.box_id,
            reception_id: this.reception_id,
          });
          let params = this.contentParams.map((item) => ({
            quantity: item.quantity,
            gtin: item.gtin && item.gtin.gtin,
            box_id: parseInt(this.box.box),
          }));
          await this.$api.orders.addContents(params);
          this.$emit("boxAdded", {
            box_id: this.box_id,
            id: this.box.box,
            gtinsCount: this.contentParams.length,
          });
          this.close();
        } catch (error) {
          if (error.response && error.response.status === 409) {
            this.errors.push("Barcode already exists");
          }
        } finally {
          this.searchGtinInput = [];
          this.loading = false;
          this.box = null;
          this.box_id = null;
          this.contentParams = [{ quantity: null, gtin: null }];
        }
      }
    },
    addNewContentRow() {
      this.contentParams.push({ quantity: null, gtin: null });
    },
  },
};
</script>

<style></style>
